
/*********************** Custom JS for Boost AI Search & Discovery  ************************/
var preOrderDateContainer = document.getElementById("release-date-onPreOrder");

const customize = {
    updateProductItemGrid: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Add extra information',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Start customization--------------------------------------------
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        let productItem = document.querySelector(`[data-product-id="${productId}"]`);

                        if (!productItem) return;

                        // Handle Pre-Order & Coming-Soon & EQL Products
                        if (productData?.tags.includes("Preorder") || productData?.tags.includes("coming-soon") || productData.tags.includes("EQL")) {
                            let buttonSelector = productItem.querySelector(".boost-sd__btn-add-to-cart span, .boost-sd__button--round span");
                            if (buttonSelector) {
                                buttonSelector.innerHTML = productData.tags.includes("Preorder") ? "Pre-order" : "Coming Soon";
                                 if( productData.tags.includes("EQL")) {
                                    buttonSelector.innerHTML = "<a href='https://pokebox.runfair.com/en-GB/au'>ENTER EQL DRAW</a>";
                                }else if(productData.tags.includes("coming-soon")){
                                    buttonSelector.innerHTML = "<a href='#' style='pointer-events: none'>Coming Soon</a>";
                                }
                            }

                            const trackItems = preOrderDateContainer.querySelectorAll(".product-lists .product--item");
                            trackItems.forEach((ele) => {
                                const eleProductId = parseInt(ele.getAttribute("data-productid"));
                                if (eleProductId === parseInt(productId)) {
                                    const productMeta = ele.getAttribute("data-product-meta");
                                    const productType = ele.getAttribute("data-template"); // "pre-orders" or "coming-soon"

                                    // Remove existing elements
                                    productItem.querySelector(".product-meta--container")?.remove();
                                    productItem.querySelector(".boost-sd_ribbon")?.remove();

                                    // Insert Release Date and Ribbon
                                    if (productMeta) {
                                        const releaseDateLayout = `<div class="product-meta--container">
                                                                    <div class="product-meta-release--date">
                                                                      <span>${productMeta}</span>
                                                                    </div>
                                                                  </div>`;
                                        productItem.querySelector(".boost-sd__product-title").insertAdjacentHTML("beforebegin", releaseDateLayout);

                                        // Set ribbon text based on product type
                                        const ribbonText = productType === "coming-soon" ? "Coming Soon" : "Pre-order";
                                        const ribbonTag = `<div class="ribbon boost-sd_ribbon ribbon-bottom-right">
                                                              <span>${ribbonText}</span>
                                                           </div>`;
                                        productItem.querySelector(".boost-sd__product-link.boost-sd__product-link-image")
                                                   .insertAdjacentHTML("beforebegin", ribbonTag);
                                    }
                                }
                            });
                        }

                        // Update Inventory Status
                        if (productData.variants[0].inventory_management == null) {
                            let inventoryStatus = productItem.querySelector(".boost-sd__inventory-status");
                            if (inventoryStatus) {
                                inventoryStatus.innerText = "In Stock";
                                inventoryStatus.style.color = "rgb(0, 138, 0)";
                            }
                        }

                        // End-------------------------------------------------------------
                    } catch (e) {
                        console.warn(e);
                    }
                }
            }),
        });
    },

    updateQuickView: (componentRegistry) => {
        componentRegistry.useComponentPlugin('QuickView', {
            name: 'Modify Quickview',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    let productData =
                        element.getParams()?.props?.productData ||
                        element.getParams()?.props?.product ||
                        element.getParams()?.props?.data; // Get product data
                    if (!productData) return;

                    if (element.getParams()?.props.isOpen == true) {
                        let quickViewSelector = document.querySelector(`.boost-sd__quick-view[product-id="${productData.id}"] .boost-sd__btn-add-to-cart span`);
                        if (quickViewSelector) {
                            if (productData?.tags.includes("Preorder")) {
                                quickViewSelector.innerHTML = "Pre-order";
                            } else if (productData?.tags.includes("coming-soon")) {
                                quickViewSelector.innerHTML = "COMING-SOON";
                            }
                        }
                    }
                },
            }),
        });
    }
};

// Register Customization
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.updateProductItemGrid,
    customize.updateQuickView
]);

